// extracted by mini-css-extract-plugin
export default {"slidingStatBar":"view_slidingStatBar__xtomt"};